import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Enrolled from "./pages/Enrolled";
import EnrollCancelled from "./pages/EnrollCancelled";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Lesson from "./pages/Lesson";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import RequireAuth from "./components/RequireAuth";
import RequireAdmin from "./components/RequireAdmin";

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Home />} />
      <Route path="/enrolled" element={<Enrolled />} />
      <Route path="/enroll-cancelled" element={<EnrollCancelled />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* Gated student app */}
      <Route
        path="/app"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/app/lesson/:lessonId"
        element={
          <RequireAuth>
            <Lesson />
          </RequireAuth>
        }
      />

      {/* Instructor admin */}
      <Route
        path="/admin"
        element={
          <RequireAdmin>
            <Admin />
          </RequireAdmin>
        }
      />

      {/* Catch-all — must be last so it only matches unknown paths */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
